<template>
  <div class="probality_index">
    <div class="pI_tabs">
      <probabilityPeriod @reloadProb="reloadProb"></probabilityPeriod>
    </div>
    <div class="pI_matches_title" style="display: none">
      <span>4 Live Matches</span>
    </div>

    <div class="pI_matches_list">
      <template v-if="!isloading">
        <template v-for="(game, index) in gameslist">
          <teamProbability :gamedata="game" :key="index"></teamProbability>
        </template>
      </template>
      <template v-if="isloading">
        <div class="pI_match_block" v-for="n in 4" :key="'skeleton-' + n">
          <v-skeleton-loader
            type="card"
            class="pI_match_info"
            style="background: #142134; border-radius: 8px 8px 0 0; padding: 10px 20px 20px 20px; min-height: 150px;"
          ></v-skeleton-loader>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import "swiper/dist/css/swiper.css";
import teamProbability from "@/views/components/teamProbability.vue";
import probabilityPeriod from "@/views/components/probabilityPeriod.vue";
export default {
  components: {
    teamProbability,
    probabilityPeriod,
  },
  methods: {
    reloadProb(date) {
      if (!date.reload) {
        this.isloading = true;
      }
      
      // Convert moment objects to ISO strings if needed (matching backend expectations)
      var startdateStr = date.date && date.date.isValid ? date.date.toISOString() : date.date;
      var enddateStr = date.edate && date.edate.isValid ? date.edate.toISOString() : date.edate;
      
      this.$store
        .dispatch("gettodayprobability2", {
          startdate: startdateStr,
          enddate: enddateStr,
        })
        .then((response) => {
          this.gameslist = [];
          var _games = [];
          if (response && response.length > 0) {
            response.forEach((element) => {
              var _e = element;
              _e["sortdate"] = moment(_e.gamedate);
              _games.push(_e);
            });
            _games = this.lodash.orderBy(_games, "sortdate", ["asc"]);
            this.gameslist = _games;
            this.isloading = false;
          } else {
            var _aresponse = JSON.parse(response);

            _aresponse.forEach((element) => {
              var _e = element;
              _e["awayteamdata"] = JSON.parse(_e.awayteamdata);
              _e["cheadtoheada"] = JSON.parse(_e.cheadtoheada);
              _e["headtoheada"] = JSON.parse(_e.headtoheada);
              _e["headtoheadh"] = JSON.parse(_e.headtoheadh);
              _e["hometeamdata"] = JSON.parse(_e.hometeamdata);
              _e["gamedatee"] = moment(_e.gamedate).add(150, "minutes");
              _e["sortdate"] = moment(_e.gamedate);

              _games.push(_e);
            });

            _games = this.lodash.sortBy(_games, "sortdate");
            this.gameslist = _games;
            if (!date.reload) {
              this.isloading = false;
            }
          }
        });
    },
  },
  mounted() {


    if(this.$store.state.user == '' || this.$store.state.user == null){

this.$router.push("/pricing");

}else{

  if ([1, 2, 3, 5].indexOf(this.$store.state.userRole) > -1) {
      var t = 100;
    } else {
      var user = this.$store.state.user;
          var payLoad = {
            subscriber: {
              name: user.name,
              email: user.email,
              phone: user.phoneNo,
              phoneCode: "+1",
            },
            page: 1,
            perpage: 100,
            appActivity: true,
          };
          this.$store
            .dispatch("subscription/getSelectedPlan", payLoad)
            .then((currentPlan) => {

              var probabiity = this.lodash.find(currentPlan, function (item) {
return item.planDetails.uniqueId.includes("PROBABILITY");
});
if(probabiity && probabiity.hasPaymentMethod == false){

this.$router.push("/plan");

}
if(probabiity == null){
this.$router.push("/plan");
}else if(moment().isAfter(moment(probabiity.expireOn))){
this.$router.push("/plan");
}else if(probabiity.cancelled){
this.$router.push("/plan");
}


            })


    }



}



  
    
  },
  data() {
    return {
      isloading: true,
      gameslist: null,
    
    };
  },
};
</script>
